/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsLokaliseString
 */
export interface ControlcenterMelcoControlCenterModelsLokaliseString {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsLokaliseString
     */
    entity_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsLokaliseString
     */
    culture_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ControlcenterMelcoControlCenterModelsLokaliseString
     */
    fields?: { [key: string]: string; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoControlCenterModelsLokaliseString
     */
    is_draft?: boolean;
}

export function ControlcenterMelcoControlCenterModelsLokaliseStringFromJSON(json: any): ControlcenterMelcoControlCenterModelsLokaliseString {
    return ControlcenterMelcoControlCenterModelsLokaliseStringFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsLokaliseStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsLokaliseString {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'culture_id': !exists(json, 'culture_id') ? undefined : json['culture_id'],
        'fields': !exists(json, 'fields') ? undefined : json['fields'],
        'is_draft': !exists(json, 'is_draft') ? undefined : json['is_draft'],
    };
}

export function ControlcenterMelcoControlCenterModelsLokaliseStringToJSON(value?: ControlcenterMelcoControlCenterModelsLokaliseString | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'culture_id': value.culture_id,
        'fields': value.fields,
        'is_draft': value.is_draft,
    };
}


